import React from "react";
import { motion, useInView } from "framer-motion";
import hero from "../../Asset/14742.jpg";

const skills = [
  { title: "Legal Expertise", width: "90%" },
  { title: "Research & Analytical Skills", width: "75%" },
  { title: "Case Management", width: "68%" },
];

const WhyChoose = () => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <div className="py-16 bg-white text-center">
      <h4 className="text-sm tracking-widest text-gray-500 uppercase">
        - Why Choose Us -
      </h4>
      <h2 className="text-4xl font-serif font-semibold mt-2">
        Experience & Expertise in{" "}
        <span className="text-[#b7b7a1]">Property Transactions</span>
      </h2>
      <p className="text-gray-600 mt-4 max-w-3xl mx-auto">
       One Stop shop for Land and Building Documentation
      </p>

      <div className="mt-12 flex flex-col lg:flex-row items-center gap-12 max-w-6xl mx-auto md:p-0 p-2">
        {/* Left Side - Image */}
        <div className="relative w-full lg:w-1/2">
          <img src={hero} alt="Expert discussing property transactions" className="shadow-lg w-full" />
        </div>

        {/* Right Side - Details */}
        <div className="w-full lg:w-1/2 text-left" ref={ref}>
          {skills.map((skill, index) => (
            <div key={index} className="mb-6">
              <h3 className="text-xl font-semibold">{skill.title}</h3>
              <div className="bg-gray-300 h-1 w-full rounded-full">
                <motion.div
                  className="bg-[#b7b7a1] h-1 rounded-full"
                  initial={{ width: "0%" }}
                  animate={{ width: isInView ? skill.width : "0%" }}
                  transition={{ duration: 1.2, ease: "easeOut" }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyChoose;
